import React from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import GiftIcon from '@wix/da-ds/pkg/Icons/24x24/Gift';
import DSModal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import Flex from '@wix/da-ds/pkg/Flex';
import FlexItem from '@wix/da-ds/pkg/Flex/Item';
import DeviantsListCard from '../../../../../../../../DeviantsList/DeviantsListCard';
import EmptyView from './EmptyView';
import s from './GiftExclusivePopup.scss';
const GiftExclusivePopup = ({ requestClose, onItemClick })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(DSModal, {
        isOpen: true,
        showHeaderBorder: true,
        useFixedMobileHeight: true,
        heading: t('popup.giftExclusive.heading'),
        className: s['root'],
        layoutClassName: s['layout-root'],
        contentClassName: s['content-root'],
        onRequestClose: requestClose,
        withScrollableContentWrapper: false,
        hasCloseButton: true
    }, /*#__PURE__*/ React.createElement("section", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement(Flex, {
        direction: "column",
        fullHeight: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['intro']
    }, t('popup.giftExclusive.body'), /*#__PURE__*/ React.createElement("div", null, t('popup.giftExclusive.body.learnMore', {
        postProcess: [
            'reactPostprocessor'
        ],
        learnLink: /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            className: s['learn-more-link'],
            href: "https://www.deviantartsupport.com/en/article/how-do-i-give-an-exclusive-to-another-deviant-as-a-gift"
        }, t('popup.giftExclusive.link.learnMore'))
    }))), /*#__PURE__*/ React.createElement(FlexItem, {
        grow: true,
        shrink: true
    }, /*#__PURE__*/ React.createElement(DeviantsListCard, {
        contentClassName: s['deviants-list'],
        onItemClick: onItemClick,
        emptyView: /*#__PURE__*/ React.createElement(EmptyView, null),
        itemSuffix: /*#__PURE__*/ React.createElement(TextButton, {
            size: "small",
            variant: "main",
            className: s['gift-button']
        }, /*#__PURE__*/ React.createElement(Flex, {
            alignItems: "center",
            justifyContent: "center",
            gap: 2
        }, /*#__PURE__*/ React.createElement(GiftIcon, {
            className: s['gift-icon'],
            disableDefaultColors: true
        }), t('popup.giftExclusive.button.giftExclusive')))
    })))));
};
GiftExclusivePopup.displayName = 'GiftExclusivePopup';
export default GiftExclusivePopup;
